/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AlarmsIndexRouteImport } from './routes/alarms/index'
import { Route as DeploymentIndexRouteImport } from './routes/deployment/index'
import { Route as MachinesMachineIdRouteImport } from './routes/machines/$machineId'
import { Route as VersionsIndexRouteImport } from './routes/versions/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AlarmsIndexRoute = AlarmsIndexRouteImport.update({
  id: '/alarms/',
  path: '/alarms/',
  getParentRoute: () => rootRouteImport,
} as any)
const DeploymentIndexRoute = DeploymentIndexRouteImport.update({
  id: '/deployment/',
  path: '/deployment/',
  getParentRoute: () => rootRouteImport,
} as any)
const MachinesMachineIdRoute = MachinesMachineIdRouteImport.update({
  id: '/machines/$machineId',
  path: '/machines/$machineId',
  getParentRoute: () => rootRouteImport,
} as any)
const VersionsIndexRoute = VersionsIndexRouteImport.update({
  id: '/versions/',
  path: '/versions/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/machines/$machineId': typeof MachinesMachineIdRoute
  '/alarms/': typeof AlarmsIndexRoute
  '/deployment/': typeof DeploymentIndexRoute
  '/versions/': typeof VersionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/machines/$machineId': typeof MachinesMachineIdRoute
  '/alarms': typeof AlarmsIndexRoute
  '/deployment': typeof DeploymentIndexRoute
  '/versions': typeof VersionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/machines/$machineId': typeof MachinesMachineIdRoute
  '/alarms/': typeof AlarmsIndexRoute
  '/deployment/': typeof DeploymentIndexRoute
  '/versions/': typeof VersionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    '/' | '/machines/$machineId' | '/alarms/' | '/deployment/' | '/versions/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/machines/$machineId' | '/alarms' | '/deployment' | '/versions'
  id:
    | '__root__'
    | '/'
    | '/machines/$machineId'
    | '/alarms/'
    | '/deployment/'
    | '/versions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MachinesMachineIdRoute: typeof MachinesMachineIdRoute
  AlarmsIndexRoute: typeof AlarmsIndexRoute
  DeploymentIndexRoute: typeof DeploymentIndexRoute
  VersionsIndexRoute: typeof VersionsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alarms/': {
      id: '/alarms/'
      path: '/alarms'
      fullPath: '/alarms/'
      preLoaderRoute: typeof AlarmsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deployment/': {
      id: '/deployment/'
      path: '/deployment'
      fullPath: '/deployment/'
      preLoaderRoute: typeof DeploymentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/machines/$machineId': {
      id: '/machines/$machineId'
      path: '/machines/$machineId'
      fullPath: '/machines/$machineId'
      preLoaderRoute: typeof MachinesMachineIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/versions/': {
      id: '/versions/'
      path: '/versions'
      fullPath: '/versions/'
      preLoaderRoute: typeof VersionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MachinesMachineIdRoute: MachinesMachineIdRoute,
  AlarmsIndexRoute: AlarmsIndexRoute,
  DeploymentIndexRoute: DeploymentIndexRoute,
  VersionsIndexRoute: VersionsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
